module.exports = CKEDITOR;